// Author YuJiaBei
// Date 2021-02-23 15:59:42

import * as model from "@/model/sithMes/mst/SithMesMstBomModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstBom(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMesMstBom',
        modelFilter: model.filter
    })
    .buildStore()
